import React from 'react';
export function Container({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`max-w-[1440px] mx-auto px-[clamp(20px,4vw,80px)] ${className}`} data-id="element-38" data-mp="3ph2jbhg0dspc">
      {children}
    </div>;
}